import { ROLE_OPTIONS } from '../constants';
import type { Role } from '../types/common';

/**
 * ユーザが持っているロール（Role[]）からRoleを返す。
 * 例）['admin'] -> 'admin'
 * @param [Role[]]
 * @returns Role | undefined
 */
const getRole = (roles: Role[]): Role | undefined => {
  // 必要なロール
  const userRequired: Role[] = ROLE_OPTIONS.USER.value;
  const poweruserRequired: Role[] = ROLE_OPTIONS.POWERUSER.value;
  const adminRequired: Role[] = ROLE_OPTIONS.ADMIN.value;
  const maintenanceadminRequired: Role[] = ROLE_OPTIONS.MAINTENANCE_ADMIN.value;

  // チェック関数
  const hasRole = (required: Role[], target: Role[]): boolean => target.every((item) => required.includes(item));

  // 一般ユーザ：['user']
  const isUser: boolean = roles && roles.length === 1 && hasRole(userRequired, roles);
  // パワーユーザ：['poweruser']
  const isPoweruser: boolean = roles && roles.length === 1 && hasRole(poweruserRequired, roles);
  // 商社アドミン：['admin']
  const isAdmin: boolean = roles && roles.length === 1 && hasRole(adminRequired, roles);
  // 保守アドミン：['maintenanceadmin']
  const isMaintenanceadmin: boolean = roles && roles.length === 1 && hasRole(maintenanceadminRequired, roles);

  // チェック内容に応じたオプションを返す
  if (isUser) {
    return ROLE_OPTIONS.USER.label;
  } else if (isPoweruser) {
    return ROLE_OPTIONS.POWERUSER.label;
  } else if (isAdmin) {
    return ROLE_OPTIONS.ADMIN.label;
  } else if (isMaintenanceadmin) {
    return ROLE_OPTIONS.MAINTENANCE_ADMIN.label;
  } else {
    return undefined;
  }
};

export default getRole;
